import { render, staticRenderFns } from "./modalPublicarTienda.vue?vue&type=template&id=70b330bc"
import script from "./modalPublicarTienda.vue?vue&type=script&lang=js"
export * from "./modalPublicarTienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports